import { appKey, apiUrl } from 'config';

export const superuserRoleKey = `${appKey}ts8r4`;
export const liteTrialRoleKey = `${appKey}ts8r26`;
export const dietologRoleKey = `${appKey}ts8r18`;

export const subscriptionExpiredProfile = `${appKey}ts18r12`;

export const defaultIcon = `${apiUrl}/images_nutrilogic/dieta_icons/universal.svg`;
